export default "/assets/images/filter-recommandation-CC.e996bd2cf1a2f7c8.webp";